/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';

  /**
   * Вид для формы изменения пароля
   */
  app.ChangePasswordFormView = app.FormView.extend({
    el: '#change-password-form',
    formName: 'change-password',
    additionalOptions: ['parent'],

    events: {
      'click #save-new-password': 'save',
      'click #cancel-change-password': 'cancel'
    },

    afterRun: function () {
      this.listenTo(this.parent, 'formPasswordToggle', this.passFormToggle);
      this.$el.find('.password').each(function () {
        new app.PasswordInputView({el: $(this)});
      });
    },

    /**
     * Сохранение нового пароля.
     */
    save: function () {
      var attributes = {};
      this.$fields.each(function () {
        attributes[this.name] = $(this).val();
      });
      this.user.save(attributes, {
        success: this.success.bind(this),
        error: this.error.bind(this),
      });
    },

    /**
     * Успешное сохранение модели
     */
    success: function () {
      var that = this;
      this.clearErrors();
      this.$fields.each(function () {
        $(this).val('');
        that.user.unset(this.name);
      });
      this.cancel();
    },
    /**
     * Закрытие/открытие блока родительского вида.
     */
    passFormToggle: function () {
      this.toggle();
    },
    /**
     * Закрытие формы и раскрытие блока родительского вида.
     */
    cancel: function () {
      this.user.set({
        oldPassword: null,
        newPassword: null,
        newPasswordConfirm: null },
        { unset: true });
      this.clearErrors();
      this.toggle();
      this.parent.toggle();
    }
  });
})(jQuery);

}.call(window));